const CLIENT_ERROR_TOAST_IDS: Record<string, string> = {
  cashbox_has_active_assignments: 'apiErrors.cashboxHasActiveAssignments',
  cashbox_system_locked: 'apiErrors.cashboxSystemLocked',
  course_in_use: 'apiErrors.courseInUse',
  course_system_locked: 'apiErrors.courseSystemLocked',
  prep_station_has_active_routes: 'apiErrors.prepStationHasActiveRoutes',
  prep_station_has_open_dispatches: 'apiErrors.prepStationHasOpenDispatches',
  prep_station_inactive_routing: 'apiErrors.prepStationInactiveRouting',
};

export const getClientErrorToastId = (code?: string) =>
  code ? CLIENT_ERROR_TOAST_IDS[code] : undefined;
